<template>
  <div id="appbar">
    <v-app-bar app elevation="0" class="white">
      <div
        class="d-flex justify-space-between align-center"
        style="width: 100%"
      >
        <div class="d-flex align-center" style="margin-left: 12px">
          <v-app-bar-nav-icon @click.stop="TOGGLE_SIDEBAR()" />
          <div
            v-if="
              isAnalystModule ||
              isExpertModule ||
              isUnderPerf ||
              isLossesWaterfall
            "
          >
            <h3 class="ml-2 font-weight-medium">
              {{ $t("_analyse_") }} -
              <router-link :to="{ path: routerLinkPath }">
                {{ pageLabel }}
              </router-link>
            </h3>
          </div>
          <h3 v-else class="font-weight-medium ml-2" style="width: 50%">
            {{ pageLabel }}
          </h3>

          <slot name="custom-selectors"></slot>

          <dates-selector-main
            v-if="show_date_selector"
            :store_date="$store.getters.dates"
            :min_date="auditDates.start"
            :max_date="auditDates.end"
            :show_label="false"
            store_cal_event="SET_MAIN_CALENDAR_REFRESH"
            store_date_commit="SET_DATES"
            class="ml-15 mt-3"
          />
          <slot></slot>
        </div>

        <div class="d-flex align-center">
          <div class="mr-6">
            <flags />
          </div>
          <div class="mr-4">
            <img
              :src="picture"
              width="50"
              height="50"
              style="border-radius: 50%"
            />
          </div>
          <div>
            <small class="mr-2 font-weight-medium">{{ name }}</small>
            <small class="grey--text capitalize">{{ role }}</small>
            <router-link class="red--text d-flex align-center" to="/logout">
              <small>{{ $t("_se_deconnecter_") }}</small>
            </router-link>
          </div>
        </div>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

import DatesSelectorMain from "@/components/Utils/DatesSelector";
import Flags from "@/components/UI_kit/Flags";

export default {
  components: {
    DatesSelectorMain,
    Flags,
  },

  data() {
    return {
      dates: {
        start: this.$store.getters.dates.start,
        end: this.$store.getters.dates.end,
      },
      auditDates: this.$store.getters.auditDates,
      show_date_selector: false,
      installation_name: "",
    };
  },

  methods: {
    ...mapMutations(["TOGGLE_SIDEBAR"]),

    getAnalysisMode() {
      let analysisModeLabel = "";
      const analysisMode = this.$store.getters.installations.find(
        (x) => x.id === this.$route.params.id
      )?.analysis_mode;

      if (analysisMode === "continuous") {
        analysisModeLabel = this.$t("_mon_installation_");
      } else {
        analysisModeLabel = this.$t("_mon_audit_");
      }

      return analysisModeLabel;
    },

    computePageLabel() {
      let sectionLabel = "";
      this.show_date_selector = false;

      if (this.$route.name === "installation-show") {
        this.show_date_selector = true;
        sectionLabel = `${this.getAnalysisMode()} - ${this.installation_name}`;
      } else if (
        this.$route.name !== null &&
        (this.$route.name.startsWith("expert") ||
          this.$route.name.startsWith("analyst"))
      ) {
        sectionLabel = this.installation_name;
      } else if (
        this.$route.name !== null &&
        ["1_niv1_evo-sous-perf", "dashboard-losses-waterfall"].includes(
          this.$route.name
        )
      ) {
        this.show_date_selector = true;
        sectionLabel = this.installation_name;
      } else if (
        this.$route.name !== null &&
        (this.isUnderPerf || this.isLossesWaterfall)
      ) {
        sectionLabel = this.installation_name;
      } else if (this.$route.name !== null && this.isSmartguardFleet) {
        sectionLabel = this.$t("_fleet_");
      }else if (this.$route.name !== null && this.isSmartguardSite) {        
        sectionLabel = "SMART GUARD -" + " "+ this.installation_name;
      }
       else {
        sectionLabel = this.$t("_analyse_"); //this.$route.meta.label
      }

      return sectionLabel;
    },
  },

  watch: {
    "$route.params.id": {
      handler: function () {
        if (this.$route.params.id != undefined) {
          this.installation_name = this.$store.getters.installations.find(
            (x) => x.id == this.$route.params.id
          )?.installation_name;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(["appTitle", "name", "picture", "role"]),

    user() {
      return this.$store.state.authStore;
    },

    routerLinkPath() {
      const fromSG = this.$route.query.fromSmartguard;
      if (fromSG === true || fromSG === "true") {
        return `/smart-guard/${this.$route.params.id}`;
      }
      return `/installations/show/${this.$route.params.id}`;
    },

    isExpertModule() {
      if (this.$route.name !== null)
        return this.$route.name.startsWith("expert");
      else return false;
    },

    isAnalystModule() {
      if (this.$route.name !== null)
        return this.$route.name.startsWith("analyst");
      else return false;
    },

    isUnderPerf() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-under-perf";
      else return false;
    },

    isLossesWaterfall() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-losses-waterfall";
      else return false;
    },

    isSmartguardFleet() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-fleet";
      else return false;
    },
    isSmartguardSite() {      
      if (this.$route.name !== null)        
        return this.$route.name === "smart-guard";
      else return false;
    },

    pageLabel() {
    return this.computePageLabel();
  },
  },
};
</script>

<style lang="scss" scoped>
#appbar {
  border-bottom: 1px solid #ededed !important;
}

a:hover {
  opacity: 0.7;
  text-decoration: underline;
}

</style>
<style>
.v-app-bar h3,
#appbar h3 {
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

#appbar .d-flex.align-center {
  flex-wrap: nowrap !important;
}
#appbar .v-menu__content {
 min-width: 40px !important;
}

</style>
